import type { CSSProperties } from "react";

const lightAvatarColorPalette = [
  { backgroundColor: "#fee2e2", color: "#991b1b" },
  { backgroundColor: "#ffedd5", color: "#9a3412" },
  { backgroundColor: "#fef3c7", color: "#92400e" },
  { backgroundColor: "#dcfce7", color: "#166534" },
  { backgroundColor: "#ccfbf1", color: "#0f766e" },
  { backgroundColor: "#dbeafe", color: "#1d4ed8" },
  { backgroundColor: "#e0e7ff", color: "#3730a3" },
  { backgroundColor: "#f3e8ff", color: "#7e22ce" },
  { backgroundColor: "#fae8ff", color: "#a21caf" },
  { backgroundColor: "#fce7f3", color: "#be185d" },
] as const;

const darkAvatarColorPalette = [
  { backgroundColor: "#7f1d1d", color: "#fecaca" },
  { backgroundColor: "#7c2d12", color: "#fed7aa" },
  { backgroundColor: "#78350f", color: "#fde68a" },
  { backgroundColor: "#14532d", color: "#bbf7d0" },
  { backgroundColor: "#134e4a", color: "#99f6e4" },
  { backgroundColor: "#1e3a8a", color: "#bfdbfe" },
  { backgroundColor: "#312e81", color: "#c7d2fe" },
  { backgroundColor: "#581c87", color: "#e9d5ff" },
  { backgroundColor: "#701a75", color: "#f5d0fe" },
  { backgroundColor: "#831843", color: "#fbcfe8" },
] as const;

const hashString = (value: string) => {
  let hash = 0;

  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }

  return hash;
};

export const getStableAvatarColorStyle = (
  seed: string | number | bigint | null | undefined,
): CSSProperties => {
  const normalizedSeed = String(seed ?? "unknown");
  const colorIndex = hashString(normalizedSeed) % lightAvatarColorPalette.length;
  const lightColor = lightAvatarColorPalette[colorIndex];
  const darkColor = darkAvatarColorPalette[colorIndex];

  return {
    backgroundColor: `light-dark(${lightColor.backgroundColor}, ${darkColor.backgroundColor})`,
    color: `light-dark(${lightColor.color}, ${darkColor.color})`,
  };
};
